import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { mxn } from "@/lib/format";
import { toast } from "sonner";

// Build 3 · Cancelar una devolución del remanente (solo administrador, motivo obligatorio).
export function CancelarDevolucionDialog({ dev, onClose, onDone }) {
  const [motivo, setMotivo] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setMotivo(""); }, [dev]);
  const cancelar = async () => {
    setSaving(true);
    try {
      const { data } = await api.post(`/factoraje/devoluciones/${dev.id}/cancelar`, { motivo });
      toast.success(`Devolución ${data.folio} cancelada. Remanente pendiente ${mxn(data.remanente?.pendiente)} (póliza inversa generada).`);
      onDone();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open={!!dev} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="cancelar-devolucion-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>Cancelar devolución {dev?.folio}</DialogTitle>
          <DialogDescription>{mxn(dev?.monto)} · el remanente vuelve a quedar pendiente y se genera la póliza inversa.</DialogDescription>
        </DialogHeader>
        <Label className="text-xs">Motivo de la cancelación <span className="text-red-600">*</span></Label>
        <Textarea data-testid="cancelar-devolucion-motivo" rows={3} value={motivo} onChange={(e) => setMotivo(e.target.value)} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={saving}>Volver</Button>
          <Button variant="destructive" data-testid="cancelar-devolucion-confirmar" onClick={cancelar}
            disabled={saving || motivo.trim().length < 4}>
            {saving && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />} Cancelar devolución
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
